import { createSlice } from '@reduxjs/toolkit'

import * as reducers from './reducers'

const feedSlice = createSlice({
  name: 'feed',
  initialState: {},
  reducers
})

export default feedSlice
